import { AccountPermissionType, SitePermissionType } from './server-types';

export const hasPermission = (permissionToCheck: string, permissions: Set<string> = new Set<string>()): boolean =>
    permissions.has(permissionToCheck);

export const hasPermissionByLevel = (isSite: boolean, permissionKeyToCheck: string, permissions: Set<string> = new Set<string>()): boolean => {
  const permission = isSite ? SitePermissionType[permissionKeyToCheck] : AccountPermissionType[permissionKeyToCheck];
  return permissions.has(permission);
};
